/*
 * Jira Ticket:
 * Created Date: Fri, 17th Jan 2020, 16:14:54 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import * as Query from './queries';
import getResponseParser from 'DataProvider/customQueryResponseParser';

export default async ({ type, resource, params, client, publicClient }) => {
  // Registration screens
  if (resource === 'Authentication') {
    if (type === 'REGISTER') {
      return Query.registerUser({ publicClient, params });
    }
    if (type === 'TERMS_CONDITIONS') {
      return Query.getTermsConditions({ publicClient });
    }
  }
  // List queries
  if (
    type === 'GET_LIST' ||
    type === 'GET_MANY_REFERENCE' ||
    type === 'GET_MANY'
  ) {
    if (resource === 'Tower') {
      const response = await Query.getListTowers({ client, params });
      return getResponseParser()(type)(response);
    }
    if (resource === 'User') {
      const response = await Query.getListUsers({ client, params });
      return getResponseParser()(type)(response);
    }
    if (resource === 'Subcontractor') {
      const response = await Query.getListSubcontracts({ client, params });
      return getResponseParser()(type)(response);
    }
  }

  if (resource === 'User' && type === 'UPDATE') {
    const transformedParams = {
      ...params,
      data: {
        ...params.data,
        certificateNumber: params.data.certificateNumber || null,
      },
    };
    const response = await Query.updateUser({
      client,
      params: transformedParams,
    });
    return getResponseParser()(type)(response);
  }
  if (resource === 'Employment' && type === 'CREATE') {
    const response = await Query.createEmployments({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'Subcontract' && type === 'ACCEPT') {
    const response = await Query.acceptSubcontract({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'Subcontract' && type === 'REJECT') {
    const response = await Query.rejectSubcontract({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'Subcontract' && type === 'REVOKE') {
    const response = await Query.revokeSubcontract({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'Tower' && type === 'CREATE') {
    const response = await Query.createTower({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'Tower' && type === 'UPDATE') {
    const response = await Query.updateTower({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'TowerType' && type === 'CREATE') {
    const response = await Query.createTowerType({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'TowerType' && type === 'GET_ONE') {
    const response = await Query.getOneTowerType({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'TowerType' && type === 'UPDATE') {
    const response = await Query.updateTowerType({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'Qualification' && type === 'GET_MANY') {
    const response = await Query.getManyQualifications({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'TowerInspection' && type === 'UPDATE') {
    const response = await Query.updateTowerInspection({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'TowerInspection' && type === 'DOWNLOAD') {
    const response = await Query.downloadTowerInspectionPdf({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'TowerInspection' && type === 'EXPORT') {
    const response = await Query.exportTowerInspectionPdf({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'ApprovedInspectionDetail' && type === 'GET_ONE') {
    const response = await Query.getOneApprovedInspectionDetail({
      client,
      params,
    });
    return getResponseParser()(type)(response);
  }
  if (resource === 'Dashboard' && type === 'GET_STATISTICS') {
    const response = await Query.getStatisticsDashboard({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'Employment' && type === 'GET_MANY_REFERENCE') {
    const response = await Query.getManyEmployment({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'Employment' && type === 'ACCEPT') {
    const response = await Query.acceptEmploymentInvite({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'Employment' && type === 'REJECT') {
    const response = await Query.rejectEmploymentInvite({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'Employment' && type === 'REVOKE') {
    const response = await Query.revokeEmploymentInvite({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'Advert' && type === 'CREATE') {
    const response = await Query.createAdvert({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'Advert' && type === 'UPDATE') {
    const response = await Query.updateAdvert({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'SubscriptionTier' && type === 'UPDATE') {
    const response = await Query.updateSubscriptionTier({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'SubscriptionTier' && type === 'CREATE') {
    const response = await Query.createSubscriptionTier({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'Capabilities' && type === 'GET_LIST') {
    const response = await Query.getListCapabilities({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'UserOrgRoles' && type === 'GET_LIST') {
    const response = await Query.getListRoles({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'Organisation' && type === 'CREATE') {
    const response = await Query.createOrganisation({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'Organisation' && type === 'GET_LIST') {
    const response = await Query.getListOrganisations({ client, params });
    return getResponseParser()(type)(response);
  }
  if (resource === 'SubscriptionTier' && type === 'CHANGE_SUBSCRIPTION') {
    const response = await Query.changeSubscriptionTier({ client, params });
    return getResponseParser()(type)(response);
  }
};
